"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MapIconInner = void 0;
var _jsxRuntime = require("react/jsx-runtime");
/**
 * SVG Path(s) for sub-icon based on type
 * @param props MapIconInnerProps
 * @returns JSX.Element
 */
const MapIconInner = props => {
  const {
    color,
    iconType
  } = props;
  const innerIcon = {
    cluster: null,
    currentLocation: null,
    pin: null,
    pickup: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M21.553 12.5478C21.2077 12.3619 20.7921 12.3619 20.4468 12.5478L14.9856 15.4885C14.5766 15.7087 14.5766 16.2954 14.9856 16.5157L20.7233 19.6052C20.896 19.6982 21.1038 19.6982 21.2764 19.6052L27.0142 16.5157C27.4232 16.2954 27.4232 15.7087 27.0142 15.4885L21.553 12.5478Z",
        fill: color
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M28.5832 17.9725C28.5832 17.5311 28.112 17.2496 27.7233 17.4589L21.89 20.5999C21.701 20.7016 21.5832 20.8989 21.5832 21.1135V28.3471C21.5832 28.8035 22.0836 29.0831 22.4723 28.8439L28.028 25.425C28.373 25.2127 28.5832 24.8365 28.5832 24.4314V17.9725Z",
        fill: color
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M19.5275 28.8439C19.9162 29.0831 20.4166 28.8035 20.4166 28.3471V21.1135C20.4166 20.8989 20.2987 20.7016 20.1098 20.5999L14.2764 17.4589C13.8878 17.2496 13.4166 17.5311 13.4166 17.9725V24.4314C13.4166 24.8365 13.6267 25.2127 13.9718 25.425L19.5275 28.8439Z",
        fill: color
      })]
    }),
    post: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M12.375 16.1875C12.375 14.8643 13.4477 13.7917 14.7708 13.7917H27.2292C28.5523 13.7917 29.625 14.8643 29.625 16.1875V24.8125C29.625 26.1357 28.5523 27.2083 27.2292 27.2083H14.7708C13.4477 27.2083 12.375 26.1357 12.375 24.8125V16.1875ZM15.0958 15.8354C14.9014 15.6559 14.5982 15.668 14.4187 15.8625C14.2392 16.0569 14.2514 16.3601 14.4458 16.5396L18.5644 20.3413L14.432 24.4737C14.2449 24.6608 14.2449 24.9642 14.432 25.1513C14.6191 25.3384 14.9225 25.3384 15.1097 25.1513L19.2691 20.9919L20.025 21.6896C20.5756 22.1979 21.4244 22.1979 21.975 21.6896L22.7309 20.9919L26.8903 25.1513C27.0775 25.3384 27.3809 25.3384 27.568 25.1513C27.7551 24.9642 27.7551 24.6608 27.568 24.4737L23.4356 20.3413L27.5542 16.5396C27.7486 16.3601 27.7608 16.0569 27.5813 15.8625C27.4018 15.668 27.0986 15.6559 26.9042 15.8354L21.325 20.9854C21.1415 21.1548 20.8585 21.1548 20.675 20.9854L15.0958 15.8354Z",
      fill: color
    }),
    spo: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M30.3634 20.4179C30.3634 25.5895 26.1716 29.7812 21 29.7812C15.8284 29.7812 11.6366 25.5895 11.6366 20.4179C11.6366 15.7908 15.0116 11.9264 19.4205 11.2188V11.2739C15.9904 12.6351 13.9226 15.8459 13.9226 19.6574C13.9226 24.5016 17.3516 27.2781 20.9989 27.2781C24.8092 27.2781 27.858 24.1754 27.858 20.419C27.858 17.1531 25.2997 14.4306 21.9247 14.4306C18.0592 14.4306 16.2086 17.9688 16.2086 17.9688H16.1546C16.1546 17.9688 17.8961 12.9062 22.9586 12.9062C26.1154 12.9062 30.3634 15.4645 30.3634 20.4179Z",
      fill: color
    })
  };
  return innerIcon[iconType];
};
exports.MapIconInner = MapIconInner;
var _default = exports.default = MapIconInner;
